import type { UserResource } from "@clerk/types";
import type { HireContact } from "~/lib/onboarding/hire-agent-preferences";

export function hireContactFromClerkUser(user: UserResource): HireContact | null {
  const email = user.primaryEmailAddress?.emailAddress?.trim();
  if (!email) return null;

  return {
    firstName: user.firstName?.trim() || "Team",
    lastName: user.lastName?.trim() || "Member",
    email,
    phone: user.primaryPhoneNumber?.phoneNumber?.trim() || undefined,
  };
}
